import { getSettingAddOriginatesFromHeader } from "@faire/deprecated-retailer-visitor-shared/settings/getSettingAddOriginatesFromHeader";
import { getCurrentPath } from "@faire/web/common/Path";
import { RawQueryParams } from "@faire/web/common/query-params/QueryParams";
import { headerInterceptorFactory } from "@faire/web/common/requests/request-interceptors/headerInterceptor";

export const HEADER_ORIGINATES_FROM_DETAILS =
  "X-FAIRE-REQUEST-ORIGINATION-DETAILS";

/**
 * Interceptor that adds the originating page as a header to outgoing requests,
 * controlled by a feature setting.
 * This helps with tracking requests user context in BE data fetches.
 *
 * @param request - The request to modify
 * @returns The modified request with the originating page header if the setting is enabled
 */
export const originatesFromDetailsClientInterceptor = headerInterceptorFactory({
  header: HEADER_ORIGINATES_FROM_DETAILS,
  value: getOriginDetailsClient,
});

export function getOriginDetailsClient(): string {
  if (!getSettingAddOriginatesFromHeader()) {
    return "";
  }
  const queryParams = getCurrentPath().searchParams;
  return getOriginDetails(queryParams);
}

export function getOriginDetails(queryParams: RawQueryParams): string {
  // If there is a refB, then the request is coming from a brand page.
  if (queryParams.getOrDefault("refB", undefined)) {
    return queryParams.getOrDefault("refB", "");
  }
  if (queryParams.getOrDefault("refS", undefined)) {
    // If there is a refS AND an impressionId, then the request is coming
    // from a search product results page.
    //
    // If there is no impressionId the request is coming from a PDP that
    // passed the search term along to the destination page.
    if (queryParams.getOrDefault("impressionId", undefined)) {
      return queryParams.getOrDefault("refS", "");
    }
    return queryParams.getOrDefault("refP", "");
  }
  if (queryParams.getOrDefault("refC", undefined)) {
    // If there is a refC AND an impressionId, then the request is coming
    // from a category page.
    //
    // If there is no impressionId the request is coming from a PDP that
    // passed the category term along to the destination page.
    if (queryParams.getOrDefault("impressionId", undefined)) {
      return queryParams.getOrDefault("refC", "");
    }
    return queryParams.getOrDefault("refP", "");
  }
  // If there is a refP and no other refs, then the request is coming from a product page
  if (queryParams.getOrDefault("refP", undefined)) {
    return queryParams.getOrDefault("refP", "");
  }

  return "";
}